import React, { useState } from "react";
import useChatStore from "../store/useChatStore";

const TicketFetched = () => {
  const [error, setError] = useState("");
  const { setCurrentScreen, inputValue, setInputValue, chatbotTheme } =
    useChatStore();

  const handleChange = (e) => {
    setInputValue(e.target.value);
    setError("");
  };
  const validateInput = () => {
    if (!inputValue) {
      return "This field is required.";
    }
    const emailRegex = /\S+@\S+\.\S+/;
    const phoneRegex = /^\d{10}$/;

    if (!emailRegex.test(inputValue) && !phoneRegex.test(inputValue)) {
      return "Please enter a valid email or phone number.";
    }

    return "";
  };
  const handleButtonClick = () => {
    const validationError = validateInput();
    if (validationError) {
      setError(validationError);
    } else {
      setError("");
      setCurrentScreen("ticketrised");
    }
  };
  return (
    <div className="login-page">
      <h2>Welcome</h2>
      <p style={{ marginBottom: "20px" }}>
        Please add your email or phone number to get your Tickets!
      </p>

      <input
        type="email"
        placeholder="Enter your email or phone number"
        value={inputValue}
        onChange={handleChange}
        className="form-input"
        style={{ marginBottom: 0 }}
      />
      {error && (
        <p style={{ color: "#ff4c4c", marginTop: "5px", textAlign: "start" }}>
          {error}
        </p>
      )}

      <button
        onClick={handleButtonClick}
        className={`form-button`}
        style={{ backgroundColor: chatbotTheme }}
      >
        <span className="button-text">Fetch Tickets</span>
      </button>
    </div>
  );
};

export default TicketFetched;
